import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { useFormik } from 'formik';
import dayjs from 'dayjs';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import CustomDatePicker from '../../../../Components/custom_components/CustomDatePicker/CustomDatePicker';
import CustomAddButton from '../../../../Components/custom_components/CustomAddButton/CustomAddButton';
import CustomBreadcrumbs from '../../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import { get_worksite_with_out_pagination } from '../../../../config/Worksite/siteApis';
import { get_equipment_with_out_pagination } from '../../../../config/Resource/equipmentApis';
import { get_technology_with_out_pagination } from '../../../../config/Resource/technologyApis';
import { get_workforce_with_out_pagination } from '../../../../config/Resource/workforceApis';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import { get_project_with_out_pagination } from '../../../../config/Worksite/projectApis';
import { scheduleProcessOptions, scheduleStatusSearchOptions, statusOptions } from '../../../../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import CustomCheckbox from '../../../../Components/custom_components/CustomCheckbox/CustomCheckbox';
import { resetMyScheduleFilter, setMyScheduleFilter } from '../../../../features/slices/myScheduleFilterSlice';

// Empty default values (use this for both reset and init)
const emptyFilters = {
    ScheduleCode: '',
    Survey_from_date: '',
    Survey_end_date: '',
    TechnologyId: '',
    WorksiteId: '',
    EmployeeId: '',
    EquipmentID: '',
    project: '',
    ScheduleStatus: '',
    schedule_process_status: '',
    Iscancel: '', // '' -- not cancel  1 -- cancel

};


function MyScheduleSearchFilter({ isAddPermission, tableTitle, isAddEdiModalOpen, handleAddEditModal, searchFilter, on_change_value, on_page_count_update }) {
    const dispatch = useDispatch();
    const persistedFilters = useSelector(state => state.myScheduleFilter.myScheduleFilter);
    
    const [technologyListing, setTechnologyListing] = useState([]);
    const [worksiteListing, setWorksiteListing] = useState([]);
    const [workforceListing, setWorkforceListing] = useState([]);
    const [equipmentListing, setEquipmentListing] = useState([]);
    const [projectListing, SetProjectListing] = useState([]);

    const fetchTechnologies = async () => {
        try {
            const response = await get_technology_with_out_pagination();
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.TechnologiesName,
                    value: item?.TechnologiesTypeId
                }));

                // Set the transformed data to the state
                setTechnologyListing(transformedData || []);
            } else {
                setTechnologyListing([]);
            }
        } catch (error) {
            console.error('Error fetching technologies:', error);
            setTechnologyListing([]);
        }
    };

    // FETCH WORKSITES 
    const fetchSites = async () => {
        try {
            const response = await get_worksite_with_out_pagination();

            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.worksiteName,
                    value: item?.WorksiteID
                }));

                // Set the transformed data to the state
                setWorksiteListing(transformedData || []);
            } else {
                setWorksiteListing([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setWorksiteListing([]);
        }
    };

    // FETCH fetchWorkforce
    const fetchWorkforce = async () => {
        try {
            const response = await get_workforce_with_out_pagination();

            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.UD_name,
                    value: item?.UD_ID
                }));

                // Set the transformed data to the state
                setWorkforceListing(transformedData || []);
            } else {
                setWorkforceListing([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setWorkforceListing([]);
        }
    };

    // FETCH PROJECTS
    const fetchProjects = async () => {
        try {
            const response = await get_project_with_out_pagination();
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.ProjectName,
                    value: item?.ProjectID
                }));

                // Set the transformed data to the state
                SetProjectListing(transformedData || []);
            } else {
                SetProjectListing([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            SetProjectListing([]);
        }
    };


    // FETCH EquipmentList 
    const fetchEquipmentList = async () => {
        try {
            // const params = {
            //     TechnologyId: formik.values.SD_TechnologyId
            // }
            const response = await get_equipment_with_out_pagination();
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.EquipmentName,
                    value: item?.EquipmentId
                }));

                // Set the transformed data to the state
                setEquipmentListing(transformedData || []);
            } else {
                setEquipmentListing([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setEquipmentListing([]);
        }
    };

    // FOR GET TECHNOLOGIES FROM LIST
    useEffect(() => {
        fetchSites()
        fetchWorkforce()
        fetchTechnologies();
        fetchProjects()
    }, []);


    const formik = useFormik({
        initialValues: {
            ...emptyFilters,
            ...persistedFilters
        },
        // enableReinitialize: true, // Auto update when Redux state changes
        // onSubmit: (values) => {
        //     searchFilter(values);
        // },
    });

    const resetFilter = () => {
        formik.resetForm({ values: emptyFilters });
        // dispatch(setMyScheduleFilter({ ...emptyFilters }));
        // dispatch(resetMyScheduleFilter());
        dispatch(setMyScheduleFilter({ ...emptyFilters }));
        on_change_value(1)
        on_page_count_update(25)

    }
    const handleModal = () => {
        handleAddEditModal(!isAddEdiModalOpen);
    };
    const breadcrumbs = ['Worksites', tableTitle]


    const handleSearch = () => {
        const values = { ...formik.values };
        dispatch(setMyScheduleFilter(values));
        on_change_value(1);                   //PASS PAGE COUNT 1 FOR GET DATA FROM ENITRE LIST
    };

    return (
        <div className="schedule-search-filter-container">
            <div className="schedule-search-filter-sub-container">
                <div className="schedule-search-filter-header">
                    <div className="schedule-search-filter-left">
                        <div className="schedule-table-title">{tableTitle}</div>
                        <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                    </div>
                    <div className="schedule-search-filter-right">
                        {isAddPermission && <CustomAddButton label="Add" onClick={handleModal} />}
                    </div>
                </div>

                <div className="search-layout-wrapper">
                    <div className="search-filter-container">
                        <div className="search-inputs-fields">
                            {/* Search fields */}
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    name="ScheduleCode"
                                    placeholder="Enter Schedule Code"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.ScheduleCode}
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="project"
                                    placeholder="Select Project"
                                    options={projectListing}
                                    value={projectListing?.find(option => option?.value === formik?.values?.project) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("project", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    width="200px"
                                    isMulti={false} // Set to false for single-select
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="WorksiteId"
                                    placeholder="Select Worksite"
                                    options={worksiteListing}
                                    value={worksiteListing.find((worksite) => worksite.value === formik.values.WorksiteId) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("WorksiteId", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.WorksiteId && Boolean(formik.errors.WorksiteId)}
                                    helperText={formik.touched.WorksiteId && formik.errors.WorksiteId}
                                    isDisabled={false}
                                    isMulti={false} // Single select
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="TechnologyId"
                                    placeholder="Select Technology"
                                    options={technologyListing}
                                    value={technologyListing.find((tech) => tech.value === formik.values.TechnologyId) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("TechnologyId", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.TechnologyId && Boolean(formik.errors.TechnologyId)}
                                    helperText={formik.touched.TechnologyId && formik.errors.TechnologyId}
                                    isDisabled={false}
                                    isMulti={false} // Single select
                                    width="200px"
                                />
                            </Grid>

                            {/* <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="EmployeeId"
                                    placeholder="Select Workforce"
                                    options={workforceListing}
                                    value={workforceListing.find((employee) => employee.value === formik.values.EmployeeId) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("EmployeeId", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.EmployeeId && Boolean(formik.errors.EmployeeId)}
                                    helperText={formik.touched.EmployeeId && formik.errors.EmployeeId}
                                    isDisabled={false}
                                    isMulti={false} // Single select
                                    width="200px"
                                />
                            </Grid> */}

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomDatePicker
                                    name="Survey_from_date"
                                    label="From Date"
                                    onChange={(date) => {
                                        formik.setFieldValue("Survey_from_date", date);
                                    }}
                                    onBlur={formik.handleBlur}
                                    // value={dayjs(formik.values.Survey_from_date, "DD-MM-YYYY")}
                                    value={formik.values.Survey_from_date ? dayjs(formik.values.Survey_from_date, "DD-MM-YYYY") : null}
                                    width="180px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomDatePicker
                                    name="Survey_end_date"
                                    label="End Date"
                                    onChange={(date) => {
                                        formik.setFieldValue("Survey_end_date", date);
                                    }}
                                    onBlur={formik.handleBlur}
                                    // value={dayjs(formik.values.Survey_end_date, "DD-MM-YYYY")}

                                    value={formik.values.Survey_end_date ? dayjs(formik.values.Survey_end_date, "DD-MM-YYYY") : null}
                                    minDate={dayjs(formik.values.Survey_from_date, "DD-MM-YYYY")} // Set minimum date

                                    width="180px"
                                />
                            </Grid>

                            <CustomSelectDropdown
                                name="schedule_process_status"
                                placeholder="Select Status"
                                options={scheduleProcessOptions}
                                value={
                                    scheduleProcessOptions?.find(option => option?.value === formik?.values?.schedule_process_status) ||
                                    scheduleProcessOptions?.find(option => option?.value === '')
                                }
                                onChange={(selectedOption) => {
                                    formik.setFieldValue("schedule_process_status", selectedOption ? selectedOption.value : '');
                                }}
                                onBlur={formik.handleBlur}
                                isDisabled={false}
                                isMulti={false} // Set to false for single-select
                                width="180px"
                            />


                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="ScheduleStatus"
                                    placeholder="Select Status"
                                    options={statusOptions}
                                    value={statusOptions?.find(option => option?.value === formik?.values?.ScheduleStatus) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("ScheduleStatus", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    isDisabled={false}
                                    isMulti={false} // Set to false for single-select
                                    width="180px"
                                />
                            </Grid>
                            {/* checkbox */}
                            <Grid item xs={12} sm={6} md={2} >
                                <CustomCheckbox
                                    label="Cancelled"
                                    checked={formik.values.Iscancel === 1} //'' -- ALL  1 -- cancel    
                                    onChange={(e) => {
                                        formik.setFieldValue("Iscancel", e.target.checked ? 1 : '')
                                        dispatch(setMyScheduleFilter({ ...formik.values, Iscancel: e.target.checked ? 1 : '' }));
                                        on_change_value(1);
                                    }
                                    }
                                />
                            </Grid>
                        </div>
                        {/* Search Button */}
                        <div className="search-buttons-fixed-right">
                            <ActionButton
                                // onClick={() => {
                                //     on_change_value(1)
                                //     searchFilter({ ...formik.values }); // Always trigger search, even if no values changed
                                // }}

                                onClick={handleSearch}
                                btnDisable={false}
                                label="Search"
                                btnType="primary"
                            />
                            <ActionButton label="Reset" btnType="outlined" onClick={resetFilter} />
                        </div>
                    </div>
                </div>


            </div>
        </div>
    );
}

export default MyScheduleSearchFilter;
